import React from "react";
import { Row, Col, Input, FormGroup, Form, Button } from "reactstrap";
import axios from "axios";
import { subscribe } from "react-contextual";

class NewsletterFooter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      messageSubmitted: false,
    };
  }

  submitNewsletterSubscriptionForm = (event) => {
    event.preventDefault();

    const name = "";
    const email = document.getElementById("ns-sub-footer-email").value;

    axios({
      method: "post",
      url: `/api/v1.1/leadGen/create`,
      data: {
        email,
        name,
        source: "newsletters",
        _csrf: this.props._csrf,
      },
    })
      .then((res) => {
        if (res.data.status) {
          const eventData = {
            content_name: "newsletter-registration",
            status: true,
          };

          if (window.eventDispatcher) {
            window.eventDispatcher.dispatchEvent("Lead", eventData, {
              fbPixel: true,
            });
          }
          this.setState({
            messageSubmitted: true,
            message: "Thank you for signing up!",
          });
        } else {
          this.setState({
            messageSubmitted: true,
            message: "You have already signed up for our newsletter",
          });
        }
      })
      .catch((err) => {});
  };

  render() {
    return (
      <Col style={{ overflow: "hidden" }}>
        <h5 style={{ color: "#444444" }}>
          Weekly dose of inspiration delivered straight to your inbox.{" "}
          <a href="/newsletters" target="_blank">
            Learn more
          </a>
          .
        </h5>
        <Col
          className="newsletter-field-panel p-0"
          style={{ overflow: "hidden" }}
        >
          <Row>
            {!this.state.messageSubmitted ? (
              <Form
                className="form-inline w-100 my-1"
                onSubmit={(e) => this.submitNewsletterSubscriptionForm(e)}
              >
                {/* <Col xs="12" lg="4" className="footer-panel-f3" >
								<FormGroup>
									<Input style={{ width: '100%' }} required type="text" name="name" id="ns-sub-footer-name" placeholder="Your Name" />
								</FormGroup>
							</Col> */}
                <Col xs="12" lg="8" className="footer-panel-f3">
                  <FormGroup>
                    <Input
                      style={{ width: "100%" }}
                      required
                      type="email"
                      name="Email"
                      id="ns-sub-footer-email"
                      placeholder="Enter your e-mail"
                    />
                  </FormGroup>
                </Col>
                <Col xs="12" lg="4" className="footer-panel-f3">
                  <FormGroup>
                    <Button
                      style={{
                        width: "100%",
                      }}
                      color="secondary"
                      className=" btn-lg"
                    >
                      {" "}
                      sign up
                    </Button>
                  </FormGroup>
                </Col>
              </Form>
            ) : (
              <div
                className="justify-content-center"
                style={{ alignItems: "center", maxWidth: "100%" }}
              >
                <p style={{ paddingTop: "1rem", fontSize: "18px" }}>
                  {this.state.message}
                </p>
              </div>
            )}
          </Row>
        </Col>
        <style global jsx>
          {`
            .newsletter-field-panel .form-inline .form-group {
              margin-bottom: 1rem;
            }
          `}
        </style>
      </Col>
    );
  }
}

export default subscribe()(NewsletterFooter);
